import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import defaultTheme from './default';
import React, { createContext, useContext, useState, useEffect } from 'react';

const darkColors = {
  primary: '#854CE6',
  primary1: '#854CE6',
  button: '#854CE6',
  background1: '#0a0e17',
  background2: '#111827',
  card: '#131b2e',
  card_light: '#162036',
  text: '#f3f4f6',
  text_primary: '#f3f4f6',
  text_secondary: '#9ca3af',
  text1: '#ffffff',
  text2: '#a78bfa',
  text3: '#9ca3af',
  white: '#ffffff',
  footerBackground: '#070a10',
  text_black: '#0f172a',
  soft2: '#9ca3af',
  border: 'rgba(133, 76, 230, 0.25)',
  shadow: 'rgba(0, 0, 0, 0.35)',
};

const lightColors = {
  primary: '#7c3aed',
  primary1: '#7c3aed',
  button: '#7c3aed',
  background1: '#f8fafc',
  background2: '#ffffff',
  card: '#ffffff',
  card_light: '#f1f5f9',
  text: '#0f172a',
  text_primary: '#0f172a',
  text_secondary: '#475569',
  text1: '#0f172a',
  text2: '#6d28d9',
  text3: '#64748b',
  white: '#ffffff',
  footerBackground: '#f1f5f9',
  text_black: '#0f172a',
  soft2: '#64748b',
  border: 'rgba(124, 58, 237, 0.2)',
  shadow: 'rgba(0, 0, 0, 0.08)',
};

export const darkTheme = {
  ...defaultTheme,
  ...darkColors,
  colors: { ...darkColors },
};

export const lightTheme = {
  ...defaultTheme,
  ...lightColors,
  colors: { ...lightColors },
};

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(true);
  const theme = darkMode ? darkTheme : lightTheme;

  useEffect(() => {
    // Keep body background and text in sync with active theme
    document.body.style.backgroundColor = theme.background1;
    document.body.style.color = theme.text_primary;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode, theme }}>
      <StyledThemeProvider theme={theme}>
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};
